/* Tandoori Masala — Diseño F · carrito, añadir platos y eventos */
(function () {
  'use strict';
  var T = window.TMF;
  if (!T) return;
  var $ = T.$, $$ = T.$$, money = T.money, esc = T.esc;
  var cart = null;

  /* Gastos de envío: producto oculto "gastos-de-envio" (variantes 1 €, 2 €, 3 €) que se añade solo */
  var FEE = T.CFG.feeVariants || {}, FEE_IDS = {};
  Object.keys(FEE).forEach(function (k) { FEE_IDS[FEE[k]] = true; });
  function isFee(it) { return !!FEE_IDS[it.variant_id] || it.handle === 'gastos-de-envio'; }
  var syncing = false;
  function syncFee(t) {
    if (!cart || syncing) return null;
    var want = t.delivery && t.feeC > 0 && t.count > 0 ? FEE[String(t.feeC / 100)] : null;
    var updates = {}, has = false, n = 0;
    cart.items.forEach(function (it) {
      if (!isFee(it)) return;
      if (it.variant_id === want) { has = true; if (it.quantity !== 1) { updates[it.variant_id] = 1; n++; } }
      else { updates[it.variant_id] = 0; n++; }
    });
    if (want && !has) { updates[want] = 1; n++; }
    if (!n) return null;
    syncing = true;
    return post('/cart/update.js', { updates: updates })
      .then(function (c) { cart = c; })
      .catch(function () {})
      .then(function () { syncing = false; render(); });
  }
  T.refreshCart = function () {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; render(); return syncFee(totals()) || c; })
      .catch(function () {});
  };
  function totals() {
    var st = T.activeStore(), tr = T.terms();
    var sub = 0, count = 0;
    if (cart) cart.items.forEach(function (it) { if (!isFee(it)) { sub += it.final_line_price; count += it.quantity; } });
    var delivery = T.state.mode === 'delivery' && !!st;
    var minC = delivery ? Math.round(tr.min * 100) : 0;
    var feeC = delivery ? Math.round(tr.fee * 100) : 0;
    return { st: st, sub: sub, minC: minC, feeC: feeC, short: delivery && sub < minC, total: sub + (count > 0 ? feeC : 0), count: count, delivery: delivery };
  }
  function render() {
    var t = totals();
    $$('[data-tm-count]').forEach(function (n) { n.textContent = t.count; n.hidden = t.count === 0; });
    $$('[data-tm-cartbar]').forEach(function (n) { n.hidden = t.count === 0; });
    $$('[data-tm-cartbar-total]').forEach(function (n) { n.textContent = money(t.total); });
    guardCartPage(t);
    var panel = $('#tm-cart');
    if (!panel) return;
    var list = $('[data-tm-lines]', panel);
    if (list && cart) {
      var shown = []; cart.items.forEach(function (it, i) { if (!isFee(it)) shown.push([it, i]); });
      list.innerHTML = !shown.length ? '<p class="tm-empty">Aún no has añadido nada.</p>' : shown.map(function (pair) {
        var it = pair[0], i = pair[1];
        var img = it.image ? '<img src="' + esc(it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=120') + '" alt="" loading="lazy">' : '<img alt="">';
        var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<small>' + esc(it.variant_title) + '</small>' : '';
        return '<div class="tm-line">' + img + '<div class="tm-line__name">' + esc(it.product_title) + variant + '</div>' +
          '<div class="tm-qty"><button type="button" aria-label="Quitar uno" data-tm-line="' + (i + 1) + '" data-q="' + (it.quantity - 1) + '">−</button><span>' + it.quantity + '</span>' +
          '<button type="button" aria-label="Añadir uno" data-tm-line="' + (i + 1) + '" data-q="' + (it.quantity + 1) + '">+</button></div>' +
          '<div class="tm-line__price">' + money(it.final_line_price) + '</div></div>';
      }).join('');
    }
    var set = function (sel, txt) { var n = $(sel, panel); if (n) n.textContent = txt; };
    set('[data-tm-sub]', money(t.sub));
    set('[data-tm-fee]', t.feeC > 0 ? money(t.feeC) : 'Gratis');
    set('[data-tm-total]', money(t.total));
    var feeRow = $('[data-tm-fee-row]', panel); if (feeRow) feeRow.hidden = !t.delivery;
    var minWrap = $('[data-tm-min]', panel);
    if (minWrap) {
      minWrap.hidden = !t.delivery || t.count === 0;
      var pct = t.minC > 0 ? Math.min(100, Math.round(t.sub / t.minC * 100)) : 100;
      var bar = $('.tm-progress', minWrap);
      if (bar) { bar.classList.toggle('is-done', !t.short); $('span', bar).style.width = pct + '%'; }
      set('[data-tm-min-text]', t.short ? 'Te faltan ' + money(t.minC - t.sub) + ' para el pedido mínimo de ' + money(t.minC) : 'Pedido mínimo alcanzado');
    }
    var btn = $('[data-tm-checkout]', panel);
    if (btn) {
      var label, ok = false;
      if (t.count === 0) label = 'Añade platos';
      else if (!T.state.mode || !t.st) label = 'Elige domicilio o recoger';
      else if (t.short) label = 'Pedido mínimo ' + money(t.minC);
      else { label = 'Ir al pago · ' + money(t.total); ok = true; }
      btn.textContent = label;
      btn.setAttribute('data-ok', ok ? '1' : '0');
      btn.classList.toggle('is-disabled', t.count === 0 || (t.short && !!T.state.mode));
      var hint = $('[data-tm-pickhint]', panel);
      if (!hint) {
        hint = document.createElement('p');
        hint.setAttribute('data-tm-pickhint', '');
        hint.style.cssText = 'margin:0;padding:10px 14px;border-radius:14px;background:var(--tm-soft);color:var(--tm-deep);font-size:14px;font-weight:700;line-height:1.4';
        btn.parentNode.insertBefore(hint, btn);
      }
      var pk = T.state.mode === 'pickup' && !!t.st && t.count > 0;
      hint.hidden = !pk;
      if (pk) hint.textContent = 'En la página de pago pulsa «Retiro» (en lugar de Envío) y elige Tandoori Masala ' + t.st.name + '. No hace falta dirección de envío.';
    }
  }
  /* También protege el botón de pago de la página /cart */
  function guardCartPage(t) {
    var btns = $$('form[action*="/cart"] [name="checkout"], #checkout');
    if (!btns.length) return;
    var block = t.count > 0 && (!T.state.mode || t.short);
    btns.forEach(function (b) { b.disabled = block; });
    var note = $('#tm-cart-guard');
    if (block) {
      if (!note) {
        note = document.createElement('div');
        note.id = 'tm-cart-guard';
        note.style.cssText = 'margin:12px 0;padding:12px 16px;border-radius:14px;background:#FFF0CC;color:#6B4300;font-weight:800;font-size:15px;';
        btns[0].parentNode.insertBefore(note, btns[0]);
      }
      note.innerHTML = !T.state.mode
        ? 'Elige <button type="button" data-tm-open="delivery" style="border:0;background:none;color:#B0174F;font-weight:800;text-decoration:underline;padding:0;cursor:pointer">a domicilio o recoger</button> antes de pagar.'
        : 'Te faltan ' + money(t.minC - t.sub) + ' para el pedido mínimo a domicilio (' + money(t.minC) + ').';
    } else if (note) note.remove();
  }
  function openCart() {
    var p = $('#tm-cart');
    if (!p) { window.location.href = '/cart'; return; }
    p.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    T.refreshCart();
  }
  function closeAll() {
    T.pendingAdd = null;
    T.closeModal();
    var p = $('#tm-cart'); if (p) p.hidden = true;
    var vm = $('#tm-variant-modal'); if (vm) vm.hidden = true;
    T.unlock();
  }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function addVariant(id, qty, btn) {
    if (btn) btn.disabled = true;
    return post('/cart/add.js', { items: [{ id: Number(id), quantity: qty || 1 }] })
      .then(function () {
        if (btn) { btn.classList.add('is-added'); setTimeout(function () { btn.classList.remove('is-added'); }, 900); }
        T.toast('Añadido al pedido');
        if (T.state.mode) T.updateCartAttributes();
        return T.refreshCart();
      })
      .catch(function (err) { T.toast((err && (err.description || err.message)) || 'No se ha podido añadir'); })
      .then(function () { if (btn) btn.disabled = false; });
  }
  function chooseVariant(handle) {
    var vm = $('#tm-variant-modal');
    if (!vm) { window.location.href = '/products/' + handle; return; }
    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        $('[data-tm-vtitle]', vm).textContent = p.title;
        $('[data-tm-vlist]', vm).innerHTML = p.variants.map(function (v) {
          return '<button type="button" class="tm-variant" data-tm-variant="' + v.id + '"' + (v.available ? '' : ' disabled') + '><span>' + esc(v.title) + (v.available ? '' : ' · Agotado') + '</span><span>' + money(v.price) + '</span></button>';
        }).join('');
        vm.hidden = false;
        document.documentElement.style.overflow = 'hidden';
      })
      .catch(function () { window.location.href = '/products/' + handle; });
  }
  /* ¿Se puede pedir este plato en el restaurante elegido? */
  function allowed(btn) {
    var holder = btn.closest('[data-tm-only]');
    if (!holder) return true;
    var list = holder.getAttribute('data-tm-only').split(',').map(function (x) { return x.trim(); });
    var st = T.activeStore();
    if (!st) {
      T.openModal('pickup', { msg: 'Este plato solo está en ' + list.map(function (id) { var s = T.storeById(id); return s ? s.name : id; }).join(' y ') + '. Elige restaurante o código postal.' });
      return false;
    }
    if (list.indexOf(st.id) === -1) { T.toast('No disponible en ' + st.name); return false; }
    return true;
  }

  T.runPendingAdd = function (el) {
    if (!el || !document.body.contains(el) || !allowed(el)) return;
    if (el.getAttribute('data-variant')) addVariant(el.getAttribute('data-variant'), 1, el);
    else if (el.getAttribute('data-handle')) chooseVariant(el.getAttribute('data-handle'));
  };

  document.addEventListener('click', function (e) {
    var t = e.target, el;
    if ((el = t.closest('[data-tm-open]'))) { e.preventDefault(); T.openModal(el.getAttribute('data-tm-open'), { after: el.getAttribute('data-tm-after') }); return; }
    if ((el = t.closest('[data-tm-pickup-store]'))) {
      e.preventDefault();
      var href = el.getAttribute('href');
      T.afterChoose = href && href !== '#' ? href : null;
      T.choose({ mode: 'pickup', store: el.getAttribute('data-tm-pickup-store') });
      return;
    }
    if (t.closest('[data-tm-close]')) { e.preventDefault(); closeAll(); return; }
    if ((el = t.closest('[data-tm-tab]')) && T.modal && T.modal.contains(el)) { T.showTab(el.getAttribute('data-tm-tab')); return; }
    if (t.closest('[data-tm-check]')) { T.checkCp(); return; }
    if ((el = t.closest('[data-tm-confirm-delivery]'))) { T.choose({ mode: 'delivery', cp: el.getAttribute('data-cp'), store: el.getAttribute('data-tm-confirm-delivery') }); return; }
    if ((el = t.closest('[data-tm-pick]'))) { T.pendingStore = el.getAttribute('data-tm-pick'); T.renderPickList(); return; }
    if (t.closest('[data-tm-confirm-pickup]')) { if (T.pendingStore) T.choose({ mode: 'pickup', store: T.pendingStore }); return; }
    if (t.closest('[data-tm-cart-open]')) { e.preventDefault(); openCart(); return; }
    if ((el = t.closest('[data-tm-line]'))) { post('/cart/change.js', { line: Number(el.getAttribute('data-tm-line')), quantity: Number(el.getAttribute('data-q')) }).then(function (c) { cart = c; render(); syncFee(totals()); }).catch(function () {}); return; }
    if ((el = t.closest('[data-tm-checkout]'))) {
      e.preventDefault();
      if (el.getAttribute('data-ok') === '1') { T.updateCartAttributes(); setTimeout(function () { window.location.href = '/checkout'; }, 250); }
      else if (!T.state.mode && cart && cart.item_count > 0) T.openModal('delivery');
      return;
    }
    if ((el = t.closest('[data-tm-add]'))) {
      e.preventDefault();
      /* Primero el código postal (pedido mínimo y envío). Al cliente habitual ya no se le pregunta. */
      if (!T.state.mode) {
        T.pendingAdd = el;
        T.openModal('delivery', { msg: 'Antes de pedir, escribe tu código postal: te decimos el pedido mínimo y el envío de tu zona.' });
        return;
      }
      T.runPendingAdd(el);
      return;
    }
    if ((el = t.closest('[data-tm-variant]'))) { addVariant(el.getAttribute('data-tm-variant'), 1).then(closeAll); return; }
    if (t === T.modal || t.id === 'tm-cart' || t.id === 'tm-variant-modal') closeAll();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target && e.target.id === 'tm-cp') { e.preventDefault(); T.checkCp(); }
    if (e.key === 'Escape') closeAll();
  });
  document.addEventListener('input', function (e) {
    if (e.target && e.target.id === 'tm-cp') { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 5); var b = $('[data-tm-cp-result]'); if (b) b.hidden = true; }
  });
  document.addEventListener('cart:refresh', T.refreshCart);

  T.renderMode();
  T.refreshCart();
  if (T.state.mode) T.updateCartAttributes();
})();